import { createContext } from 'react';
import { DeviceEnum } from '../enums/enums';
export default createContext({
    deviceSize: DeviceEnum.Big,
    hasFloatMenu: false
});
